import React, { useState, useContext } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from './AuthContext';
import SEO from './SEO';
import './Login.css';
import PasswordVisibilityIcon from './PasswordVisibilityIcon';

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState('');
  const { logIn } = useContext(AuthContext);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate(); // Initialize useNavigate hook
  const location = useLocation(); // Use location hook to get the current location
  const from = location.state?.from?.pathname || '/dashboard'; // Determine the redirect path

  const handleLogin = (e) => {
    e.preventDefault();

    if (!email || !password) {
      setErrorMessage('Please enter both email and password.');
      return;
    }

    setErrorMessage('');

    fetch('/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email,
        password
      })
    })
    .then(response => response.json())
    .then(data => {
      if (data.message === 'Logged in') {
        setErrorMessage('');
        if (data.token) localStorage.setItem('token', data.token);
        logIn(data.user); // Update the user state to indicate that the user is logged in
        navigate(from, { replace: true }); // Redirect to dashboard
      } else {
        setErrorMessage(data.message);
      }
    })
    .catch(err => {
      console.error('Error: ', err);
      setErrorMessage('An error occurred. Please try again.');
    });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="auth-container">
      <SEO title="Log In" />
      <form className="auth-form" onSubmit={handleLogin}>
        <div className="auth-header">
          <p>Welcome back</p>
          <h1>Log in to VetBill</h1>
        </div>
        {errorMessage && <div className="error-message">{errorMessage}</div>}
        <label>Email
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} required />
        </label>
        <label>Password
          <div className="password-container">
            <input 
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={e => setPassword(e.target.value)} 
              required 
            />
            <button type="button" className="toggle-password" onClick={togglePasswordVisibility} aria-label={showPassword ? 'Hide password' : 'Show password'}>
              <PasswordVisibilityIcon visible={showPassword} />
            </button>
          </div>
        </label>
        <div className="login-group">
          <button type="submit" className="login-button">Login</button>
          <Link to="/forgot-password" className="forgot-password">Forgot password?</Link>
        </div>
        <div className="signup-prompt">
          <p>Don't have an account?</p>
          <Link to="/signup" className="signup-button">Sign up</Link> 
        </div>
      </form>
    </div>
  );
};

export default Login;
